import { render, staticRenderFns } from "./OfficeSubject.vue?vue&type=template&id=2eecf27e&scoped=true&"
import script from "./OfficeSubject.vue?vue&type=script&lang=js&"
export * from "./OfficeSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eecf27e",
  null
  
)

export default component.exports